module.exports = __webpack_public_path__ + "c45ef5a42bf88434317c959cac7fedcf.pdf";